/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S4_P1_PreInputs */

const tr_kvkkbasvuru_s4_p1_pre = /** @type {(inputs: Kvkkbasvuru_S4_P1_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başvurularınız KVKK Madde 13/2 uyarınca en geç `)
};

const en_kvkkbasvuru_s4_p1_pre = /** @type {(inputs: Kvkkbasvuru_S4_P1_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pursuant to KVKK Article 13/2, your applications are concluded free of charge within at most `)
};

const de_kvkkbasvuru_s4_p1_pre = /** @type {(inputs: Kvkkbasvuru_S4_P1_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Anträge werden gemäß KVKK Artikel 13/2 spätestens innerhalb von `)
};

const ru_kvkkbasvuru_s4_p1_pre = /** @type {(inputs: Kvkkbasvuru_S4_P1_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Согласно статье 13/2 KVKK ваши обращения рассматриваются бесплатно в срок не более `)
};

/**
* | output |
* | --- |
* | "Pursuant to KVKK Article 13/2, your applications are concluded free of charge within at most" |
*
* @param {Kvkkbasvuru_S4_P1_PreInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s4_p1_pre = /** @type {((inputs?: Kvkkbasvuru_S4_P1_PreInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S4_P1_PreInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s4_p1_pre(inputs)
	if (locale === "de") return de_kvkkbasvuru_s4_p1_pre(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s4_p1_pre(inputs)
	return tr_kvkkbasvuru_s4_p1_pre(inputs)
});